import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * PublicRoute component for handling public routes like login/register
 * Automatically redirects authenticated users to dashboard
 */
const PublicRoute = ({ component: Component, restricted = false, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated ?? false);

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated && restricted ? (
          <Redirect to="/dashboard" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute; 